{
  "noPrice": "Sans prix",
  "noPriceText": "{{name}} n'a pas de prix sur la liste de ce magasin : il ne peut pas être vendu ici.",
  "gate": {
    "notPaired": "Ce navigateur n'est pas une caisse",
    "notPairedText": "La caisse fonctionne sur le navigateur d'une caisse enregistreuse. Un responsable associe ce navigateur à une caisse sur la page Caisses.",
    "registers": "Caisses",
    "unavailable": "La caisse ne peut pas démarrer",
    "noShift": "{{register}} n'a pas de service ouvert",
    "noShiftText": "Comptez le fond de caisse pour ouvrir le service, puis vendez.",
    "noShiftAsk": "Demandez à un caissier ou à un responsable d'ouvrir le service de cette caisse.",
    "openShift": "Ouvrir le service"
  },
  "header": {
    "cashier": "Caissier : {{name}}",
    "shift": "service ouvert {{time}}",
    "offline": "Hors ligne",
    "pickups_one": "{{count}} retrait en attente",
    "pickups_many": "{{count}} retraits en attente",
    "pickups_other": "{{count}} retraits en attente",
    "return": "Retour",
    "pickupsButton": "Retraits",
    "parked": "En attente",
    "more": "Autres actions",
    "cod": "Espèces des livreurs",
    "movement": "Entrée ou sortie d'espèces",
    "drawer": "Ouvrir le tiroir",
    "x": "Rapport X",
    "close": "Fermer le service",
    "closeBusy": "Terminez d'abord le ticket",
    "fullscreen": "Plein écran",
    "exit": "Quitter la caisse",
    "sales": "Ventes"
  },
  "catalog": {
    "title": "Produits",
    "search": "Scannez ou cherchez un produit (F2)",
    "clear": "Effacer la recherche",
    "view": "Produits affichés",
    "favorites": "Favoris",
    "all": "Tous",
    "loading": "Chargement du catalogue…",
    "empty": "Rien à vendre ici pour l'instant",
    "noMatch": "Rien ne correspond à « {{query}} »",
    "notFound": "Aucun produit avec le code {{code}}",
    "variants_one": "{{count}} variante",
    "variants_many": "{{count}} variantes",
    "variants_other": "{{count}} variantes",
    "from": "à partir de {{amount}}",
    "show": "Retour aux produits"
  },
  "stock": {
    "left": "{{quantity}} {{unit}} en stock ici",
    "leftShort": "{{quantity}} en stock",
    "out": "Épuisé"
  },
  "favorites": {
    "add": "Ajouter {{name}} aux favoris",
    "remove": "Retirer {{name}} des favoris",
    "full": "Une caisse affiche {{max}} favoris au plus"
  },
  "keypad": {
    "back": "Effacer (double appui : tout effacer)"
  },
  "ticket": {
    "title": "Ticket",
    "walkIn": "Client de passage",
    "addCustomer": "Ajouter un client par téléphone",
    "empty": "Le ticket est vide",
    "emptyHint": "Scannez un produit ou touchez-le à gauche.",
    "unknown": "N'est plus vendu ici",
    "unknownText": "Retirez d'abord du ticket les lignes qui ne sont plus vendues ici.",
    "answer": "À renseigner : {{names}}",
    "short": "Seulement {{quantity}} en stock ici",
    "less": "Un {{name}} de moins",
    "more": "Un {{name}} de plus",
    "discount": "Remise",
    "promoCode": "Code promo",
    "park": "Mettre en attente",
    "gross": "Avant remises",
    "discounts": "Remises",
    "total": "Total",
    "overLimit": "Les remises dépassent votre limite : un responsable les autorise à l'encaissement.",
    "pay": "Encaisser {{amount}}",
    "full": "Un ticket compte {{max}} lignes au plus",
    "show": "Ticket ({{count}}) · {{amount}}",
    "lineDiscount": "−{{amount}} · {{unit}} par unité · {{percent}} %",
    "noWholesale": "Pas de prix de gros",
    "removeLine": "Retirer {{name}} du ticket"
  },
  "line": {
    "editing": "Ce que le pavé modifie",
    "quantity": "Quantité",
    "discountAmount": "Remise TND",
    "discountPercent": "Remise %",
    "gross": "Prix × quantité",
    "discount": "Remise",
    "total": "Total de la ligne",
    "customizations": "Sur mesure",
    "remove": "Supprimer la ligne",
    "apply": "Appliquer",
    "add": "Ajouter au ticket",
    "unitPrice": "Prix unitaire",
    "perUnit": "Par unité"
  },
  "variants": {
    "priceRange": "de {{from}} à {{to}}",
    "pick": "Choisir : {{option}}",
    "choose": "Choisissez une variante",
    "add": "Ajouter {{label}}"
  },
  "discount": {
    "title": "Remise sur le ticket",
    "hint": "Répartie entre les lignes, sur {{amount}}.",
    "mode": "Remise en",
    "apply": "Accorder {{amount}}",
    "removeAll": "Aucune remise",
    "overLimit": "Au-delà de votre limite de {{percent}} % : la vente demandera un responsable."
  },
  "code": {
    "title": "Code promo",
    "hint": "Le code donné par le client. La promotion qui le demande s'applique alors au ticket.",
    "apply": "Appliquer",
    "remove": "Retirer le code"
  },
  "customer": {
    "title": "Client",
    "hint": "Retrouvez-le par téléphone ou par nom, ou enregistrez un nouveau client.",
    "walkIn": "Client de passage"
  },
  "park": {
    "title": "Mettre le ticket en attente",
    "hint": "Il attend sur cette caisse jusqu'à ce qu'on le reprenne.",
    "label": "Nom pour le retrouver",
    "labelHint": "Facultatif : le nom du client, « veste bleue »…",
    "confirm": "Mettre en attente",
    "done": "Ticket mis en attente"
  },
  "parked": {
    "title": "Tickets en attente",
    "none": "Aucun ticket en attente",
    "noneHint": "Les tickets mis de côté sur cette caisse apparaissent ici.",
    "busy": "Terminez ou mettez en attente le ticket à l'écran avant d'en reprendre un autre.",
    "unnamed": "Ticket",
    "lines_one": "{{count}} ligne",
    "lines_many": "{{count}} lignes",
    "lines_other": "{{count}} lignes",
    "by": "mis en attente par {{name}}, {{time}}",
    "recall": "Reprendre"
  },
  "pay": {
    "title": "Paiement",
    "total": "À payer",
    "left": "Reste à payer",
    "over": "Trop perçu",
    "pickMethod": "Touchez le mode de paiement. Plusieurs modes font un paiement fractionné.",
    "amount": "Montant",
    "removePayment": "Retirer ce paiement",
    "shortCash": "Moins que le montant : les espèces remises doivent le couvrir.",
    "keypadHint": "Touchez un montant pour le saisir ici.",
    "complete": "Terminer la vente"
  },
  "pending": {
    "title": "Vente non confirmée",
    "text": "Le serveur n'a pas répondu. Renvoyez-la : une vente envoyée deux fois n'est enregistrée qu'une fois.",
    "retry": "Renvoyer",
    "abandon": "Modifier le ticket",
    "abandonConfirm": "Si la vente est passée, elle figure dans les commandes avec son ticket de caisse. Modifier le ticket quand même ?"
  },
  "done": {
    "title": "Vente terminée · {{number}}",
    "order": "Commande {{number}}",
    "total": "Payé",
    "print": "Réimprimer",
    "next": "Client suivant"
  },
  "returns": {
    "title": "Retour en caisse",
    "hint": "À partir du ticket : les articles reviennent en rayon dans ce magasin, l'argent est rendu, un avoir est émis.",
    "number": "Numéro du ticket",
    "find": "Chercher",
    "notFound": "Aucun ticket avec ce numéro",
    "reprint": "Réimprimer le ticket",
    "sold": "{{quantity}} vendu(s), {{amount}}",
    "returnable": "{{quantity}} peut revenir",
    "nothingLeft": "plus rien à retourner",
    "less": "Un {{name}} de moins en retour",
    "more": "Un {{name}} de plus en retour",
    "refundMethod": "Remboursement",
    "asPaid": "Comme il a été payé",
    "lateTitle": "Le délai de retour est dépassé",
    "lateText": "Un responsable l'accepte : il lui sera demandé au moment de reprendre les articles.",
    "lateAllowed": "Vous pouvez l'accepter malgré tout.",
    "confirm": "Reprendre · {{amount}}",
    "doneTitle": "Retour enregistré",
    "creditNote": "Avoir {{number}}",
    "giveBack": "À rendre en espèces",
    "noRefund": "Rien à rendre : la vente n'était pas payée.",
    "confirmManager": "Demander à un responsable · reprendre {{amount}}",
    "findSale": "Pas de ticket ? Retrouver la vente"
  },
  "pickups": {
    "title": "Retraits dans ce magasin",
    "hint": "Les commandes en ligne que le client retire ici. Le reste dû se paie en caisse.",
    "none": "Aucun retrait en attente",
    "ready": "Prête",
    "notReady": "Pas encore prête",
    "due": "{{amount}} dû",
    "paid": "Payée",
    "collect": "Remettre",
    "payAndCollect": "Encaisser et remettre",
    "payTitle": "Paiement de {{number}}"
  },
  "cod": {
    "title": "Espèces des livreurs",
    "hint": "Les espèces qu'un livreur rapporte pour les commandes livrées, dans ce tiroir.",
    "none": "Aucun contre-remboursement en attente",
    "confirm": "Mettre {{amount}} dans le tiroir"
  },
  "x": {
    "title": "Rapport X",
    "hint": "{{register}} : le service jusqu'ici. Rien n'est clôturé.",
    "figures": "Encaissé dans ce service"
  },
  "drawer": {
    "title": "Ouvrir le tiroir",
    "hint": "Le tiroir de {{register}} s'ouvre avec un ticket « sans vente », et le journal d'activité indique qui l'a ouvert.",
    "reason": "Motif",
    "confirm": "Ouvrir"
  },
  "receipt": {
    "types": {
      "receipt": "Ticket de caisse",
      "invoice": "Facture",
      "creditNote": "Avoir"
    },
    "copy": "Duplicata",
    "taxId": "Matricule fiscal",
    "register": "Caisse : {{name}}",
    "cashier": "Caissier : {{name}}",
    "order": "Commande {{number}}",
    "customer": "Client : {{name}}",
    "corrects": "Corrige {{number}}",
    "refundLine": "Remboursement",
    "discount": "Remise",
    "discounts": "Remises",
    "total": "Total",
    "totalCredit": "Avoir",
    "vat": "TVA {{rate}} % sur {{base}}",
    "tendered": "Remis",
    "change": "Rendu",
    "refunded": "Rendu · {{method}}",
    "amountsIn": "Montants en TND, TVA comprise.",
    "thanks": "Merci et à bientôt !",
    "noSale": "Sans vente",
    "cancelled": "Annulé",
    "paymentCorrected": "Paiement corrigé"
  },
  "sales": {
    "title": "Ventes de la caisse",
    "hint": "Retrouvez un ticket pour le réimprimer, reprendre des articles ou le corriger.",
    "search": "Ticket, client, montant, ou scannez un produit",
    "period": "Période",
    "periods": {
      "shift": "Ce service",
      "today": "Aujourd'hui",
      "7d": "7 jours",
      "day": "Un jour"
    },
    "date": "Jour",
    "store": "Toutes les caisses du magasin",
    "none": "Aucun ticket pour l'instant",
    "noneHint": "Rien n'a été vendu ici sur cette période.",
    "noMatch": "Aucun ticket ne correspond",
    "noMatchHint": "Essayez une autre période ou toutes les caisses ; si la vente reste introuvable, reprenez les articles sans ticket.",
    "more": "Les {{count}} derniers tickets sont affichés : affinez la recherche pour voir les plus anciens.",
    "states": {
      "paid": "Payé",
      "partlyPaid": "Payé en partie",
      "partlyReturned": "Retourné en partie",
      "returned": "Retourné",
      "cancelled": "Annulé",
      "refund": "Sans ticket"
    },
    "kinds": {
      "pickup": "Retrait"
    },
    "lines_one": "{{count}} ligne",
    "lines_many": "{{count}} lignes",
    "lines_other": "{{count}} lignes",
    "noReceipt": "Reprendre sans ticket",
    "back": "Tous les tickets",
    "open": "Ouvrir {{number}}"
  },
  "ticketView": {
    "title": "Ticket {{number}}",
    "refundTitle": "Repris sans ticket · {{number}}",
    "order": "Commande {{number}}",
    "lines": "Articles",
    "sold": "{{quantity}} × {{price}}",
    "discount": "{{amount}} de remise",
    "returned": "{{quantity}} retourné(s)",
    "payments": "Argent",
    "noPayment": "Aucun paiement.",
    "refund": "Remboursement",
    "voided": "Annulé",
    "refunded": "{{amount}} remboursé",
    "correct": "Corriger",
    "documents": "Documents",
    "print": "Imprimer",
    "openA4": "Ouvrir pour imprimer (A4)",
    "cancelled": "Annulé le {{date}} par {{by}}",
    "approvedBy": "autorisé par {{name}}",
    "late": "Délai de retour dépassé : un responsable accepte le retour.",
    "manager": "Un responsable l'autorise",
    "backOffice": "Ouvrir dans la gestion",
    "backToTicket": "Retour au ticket",
    "customerSet": "{{name}} est le client de ce ticket",
    "actions": {
      "reprint": "Réimprimer",
      "takeBack": "Reprendre des articles",
      "cancel": "Annuler la vente",
      "correctPayment": "Corriger un paiement",
      "invoice": "Facture",
      "setCustomer": "Ajouter le client"
    },
    "listPrice": "prix catalogue {{price}}"
  },
  "cancel": {
    "title": "Annuler {{number}}",
    "hint": "Tout revient en rayon dans ce magasin et le client récupère son argent. Un avoir corrige le ticket.",
    "items": "Articles remis en rayon",
    "voided": "Retiré de ce service, comme jamais payé",
    "refunded": "Remboursé depuis ce tiroir",
    "reason": "Pourquoi",
    "confirm": "Annuler la vente",
    "confirmManager": "Demander à un responsable · annuler la vente",
    "done": "Vente annulée",
    "doneTitle": "Vente {{number}} annulée"
  },
  "correct": {
    "title": "Corriger le paiement · {{method}} {{amount}}",
    "hint": "Saisissez le paiement tel qu'il a vraiment été fait : le mauvais est annulé dans ce service et le ticket ne change pas.",
    "confirm": "Enregistrer le bon paiement",
    "confirmManager": "Demander à un responsable · enregistrer",
    "done": "Paiement corrigé"
  },
  "invoice": {
    "title": "Facture pour {{number}}",
    "hint": "À la demande du client, avec son nom et son matricule fiscal. Elle s'imprime en A4 depuis sa page.",
    "buyerName": "Nom ou société",
    "buyerTaxId": "Matricule fiscal",
    "buyerTaxIdHint": "Pour une société.",
    "buyerAddress": "Adresse",
    "confirm": "Émettre la facture",
    "done": "Facture {{number}} émise",
    "doneHint": "Ouvrez-la pour l'imprimer en A4, ou retrouvez-la plus tard dans les documents de ce ticket."
  },
  "noReceipt": {
    "title": "Reprendre sans ticket",
    "hint": "Quand la vente reste introuvable : les articles reviennent au prix du jour, dans le stock de ce magasin.",
    "search": "Scannez ou tapez le produit rapporté",
    "notFound": "Non vendu à cette caisse.",
    "empty": "Ajoutez les articles rapportés.",
    "price": "{{price}} aujourd'hui",
    "remove": "Retirer {{name}}",
    "cash": "L'argent est rendu en espèces depuis ce tiroir, et un avoir est imprimé.",
    "confirm": "Rendre {{amount}} en espèces",
    "confirmManager": "Demander à un responsable · rendre {{amount}}",
    "doneTitle": "Articles repris · {{number}}"
  },
  "approval": {
    "title": "Demander à un responsable",
    "hint": "Un responsable s'identifie ici pour cette seule action. Votre session reste ouverte.",
    "username": "Identifiant du responsable",
    "password": "Mot de passe",
    "confirm": "Autoriser",
    "given": "Autorisé par {{name}}",
    "permissions": {
      "voidSale": "Annuler une vente ou corriger un paiement",
      "refundWithoutReceipt": "Reprendre des articles sans ticket",
      "acceptLateReturn": "Accepter un retour hors délai",
      "giveLargeDiscount": "Accorder des remises au-delà de la limite du caissier"
    },
    "invalid": {
      "credentials": "Identifiant ou mot de passe incorrect.",
      "permission": "Cette personne ne peut pas l'autoriser.",
      "site": "Cette personne ne travaille pas dans ce magasin.",
      "expired": "L'autorisation n'est plus valable : redemandez-la."
    }
  },
  "mode": {
    "label": "Prix",
    "retail": "Détail",
    "wholesale": "Gros",
    "banner": "Prix de gros",
    "confirm": "Changer les prix de ce ticket ? Ses remises et les prix saisis sont retirés : ils étaient donnés sur les autres prix.",
    "noWholesaleText": "{{name}} n'a pas de prix de gros : fixez-le sur l'article, ou vendez-le en mode détail."
  },
  "hint": {
    "add": "Ajouter",
    "free_one": "Encore {{count}} : offert · {{name}}",
    "free_many": "Encore {{count}} : offerts · {{name}}",
    "free_other": "Encore {{count}} : offerts · {{name}}",
    "reduced_one": "Encore {{count}} à −{{percent}} % · {{name}}",
    "reduced_many": "Encore {{count}} à −{{percent}} % · {{name}}",
    "reduced_other": "Encore {{count}} à −{{percent}} % · {{name}}",
    "pieces_one": "Encore {{quantity}} pour {{name}}",
    "pieces_many": "Encore {{quantity}} pour {{name}}",
    "pieces_other": "Encore {{quantity}} pour {{name}}",
    "amount": "Encore {{amount}} pour {{name}}",
    "pack": "Ajoutez {{quantity}} × {{product}} : {{name}}"
  }
}
